<template>
    <section>
        <!-- 顶部banner -->
        <div class="banner-row">
            <div
                class="bg-lazy top-banner"
                v-lazy:background-image="item.img"
                v-for="item in promotion"
                :key="item.id"
                @click="linkTo(item, 'promo')"
            ></div>
        </div>

        <!-- 滚动banner -->
        <div class="banner-list-container">
            <ul class="banner-list">
                <li
                    class="bg-lazy list-item"
                    v-for="(item, index) in banner"
                    :key="index"
                    v-lazy:background-image="item.img"
                    @click="linkTo(item)"
                ></li>
            </ul>
        </div>
    </section>
</template>

<script>
import { linkTo } from "@/lib/utils";
import { bannerGtag, promotionHotelGtag } from "@/lib/gtag.js";

export default {
    data() {
        return {
            banner: [],
            promotion: []
        };
    },
    created() {
        this.getBanner();
    },
    methods: {
        getBanner() {
            let params = {};
            let lang = this.$local.get("lang") || "en-US";

            //为繁体时需加入参数
            if (lang === "zh-HK") {
                params.lang_ext = "zh-cn";
            }

            this.$req.get("v2/banner", params).then(({ data }) => {
                if (data.code === "2000") {
                    this.banner = data.data.filter(item => item.type == 1);
                    this.promotion = data.data.filter(item => item.type == 2);
                }
            });
        },

        /**
         * 跳转
         * @param {any} item 包含跳转链接
         * @param {String} type 跳转类型，非必须，为promo则表示跳转站内且嵌套网页
         */
        linkTo(item, type) {
            //埋点
            if (type === "promo") {
                promotionHotelGtag(item.location);
            } else {
                bannerGtag(item.location);
            }

            if (type === "promo" || item.location === "接送车") {
                linkTo("/promotion/" + btoa(encodeURIComponent(item.link)));
                return;
            }
            if (item.link.indexOf("#") === 0) {
                //站内跳转
                let path = item.link.split("/")[1];
                linkTo("/" + path);
                return;
            }
            window.open(item.link, "_blank");
        }
    }
};
</script>

<style lang="scss" scoped>
.banner-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;

    .top-banner {
        width: 561px;
        height: 235px;
        border-radius: 10px;
        cursor: pointer;
    }
}

.banner-list-container {
    overflow: hidden;
    width: 100%;
}
.banner-list {
    display: flex;
    overflow-x: auto;
    width: 3000px;
    .list-item {
        height: 170px;
        width: 366px;
        border-radius: 10px;
        margin-right: 20px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Banner.vue